import { api, apiCall } from './apiClient';
import type { Product, ProductListResponse, ProductDetailResponse, ApiResponse } from '../types/product';

export interface ProductListParams {
  page: number;
  size: number;
  search?: string;
  groupId?: string; // 商品组ID（可选，用于查询商品组关联的商品）
}

export const productService = {
  // 获取商品列表
  getProductList: async (params: ProductListParams): Promise<ProductListResponse> => {
    return api.get('/admin/shopProduct/page', { params });
  },

  // 获取商品详情
  getProductDetail: async (id: string): Promise<ProductDetailResponse> => {
    return api.get('/admin/shopProduct/detail', { params: { id } });
  },

  // 新增商品
  addProduct: async (data: Partial<Product>): Promise<ApiResponse<string>> => {
    return apiCall.post('/admin/shopProduct/add', data);
  },

  // 更新商品
  updateProduct: async (id: string, data: Partial<Product>): Promise<ApiResponse<string>> => {
    return apiCall.post('/admin/shopProduct/update', { ...data, id });
  },

  // 删除商品
  deleteProduct: async (id: string): Promise<ApiResponse<string>> => {
    return apiCall.post('/admin/shopProduct/delete', null, { 
      id: id
    });
  },

  // 批量删除商品
  batchDeleteProducts: async (ids: string[]): Promise<ApiResponse<string>> => {
    return apiCall.post('/admin/shopProduct/batchDelete', { ids });
  },

  // 上架商品
  onlineProduct: async (id: string): Promise<ApiResponse<string>> => {
    return apiCall.post('/admin/shopProduct/online', null, { 
      id: id
    });
  },

  // 下架商品
  offlineProduct: async (id: string): Promise<ApiResponse<string>> => {
    return apiCall.post('/admin/shopProduct/offline', null, { 
      id: id
    });
  },
};
